import { DocumentDigital } from 'shell/view-models/act-form';
import { DocumentPaper } from 'shell/view-models/document-paper';

export const emptyPaper: DocumentPaper = {
  actDate: null,
  actNumber: '',
  actPart: '',
  actSeries: '',
  actVolume: '',
  actYear: '',
  transcribed: false,
  actMunicipality: null,
};

export const emptyDigital: DocumentDigital = {
  documentDate: null,
  idAnsc: '',
  istatCode: '',
  municipality: null,
  numberMunicipality: '',
  transcript: false,
  year: '',
};
